import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { aiReportTypes } from '../types';
import { saveDialogFiles } from '../utils/downloadDialogs';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'export-page-report-dialogs';

export const exportPageReportDialogs: aiReportTypes.ExportDialogs = (params) => {
  return axios.post('/page-reports/export', params);
};

type MutationFnType = typeof exportPageReportDialogs;

type UseExportPageReportDialogsOptions = {
  config?: MutationConfig<MutationFnType>;
};

export const useExportPageReportDialogs = ({
  config = {},
}: UseExportPageReportDialogsOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: exportPageReportDialogs,
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Собираем диалоги...');
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      saveDialogFiles(args[0].files);
      const count = args[0].files.length;
      toasts.loadingToast.success(
        TOAST_ID,
        count === 1 ? 'JSON скачан' : `Скачано файлов: ${count}`
      );
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error?: string }>, ...args) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      config.onError?.(error, ...args);
    },
  });
};
